// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__qnQJE","header":"styles_header__+Mhkp","text_wrapper":"styles_text_wrapper__QxZ7C","content":"styles_content__ERmiZ"};